import { render } from "./Teksten.vue?vue&type=template&id=1bfbfe87&scoped=true"
import script from "./Teksten.vue?vue&type=script&lang=js"
export * from "./Teksten.vue?vue&type=script&lang=js"

import "./Teksten.vue?vue&type=style&index=0&id=1bfbfe87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfbfe87"]])

export default __exports__